"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const InsertLinkOutlined_1 = __importDefault(require("@mui/icons-material/InsertLinkOutlined"));
const material_1 = require("@mui/material");
const Typography_1 = __importDefault(require("@mui/material/Typography"));
const useAppUid_1 = require("../../../webapp/behaviours/useAppUid");
const WebsiteWrapper = styled_components_1.default.a `
  display: flex;
  position: relative;
  justify-content: start;
  flex-wrap: wrap;
  flex-direction: column;
  cursor: pointer;
  align-items: center;

  &.style-for-convention {
    padding: 0 16px;

    a {
      margin-bottom: 10px;
    }
  }
`;
const ExternalLink = styled_components_1.default.a `
  display: block;
  color: inherit !important;
  width: 100%;
`;
const Icon = styled_components_1.default.div `
  width: 40px;
  height: 40px;

  text-align: center;
  background-color: ${(props) => `${props.theme.palette.mainAppColor.light}`};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;

  @media screen and (max-width: 700px) {
    width: 44px;
    height: 44px;
  }
`;
const Text = styled_components_1.default.div `
  padding-top: 5px;
  text-align: center;
`;
const withHttp = (url) => (!/^https?:\/\//i.test(url) ? `http://${url}` : url);
const WebsiteTab = (props) => {
    const { url, text, type, renderFromConvention } = props;
    const transformBookingUrl = (0, useAppUid_1.useAppUid)();
    const processedUrl = transformBookingUrl(withHttp(url));
    if (type === "circle") {
        return (react_1.default.createElement(WebsiteWrapper, { target: "_blank", href: processedUrl, className: renderFromConvention ? "style-for-convention" : "" },
            react_1.default.createElement(Icon, { className: "call-to-action-icon", styleConvention: renderFromConvention },
                react_1.default.createElement(InsertLinkOutlined_1.default, { htmlColor: "black" })),
            react_1.default.createElement(Text, { className: "call-to-action-text" }, process.env.PLATFORM === "webapp" ? (react_1.default.createElement(Typography_1.default, { variant: "caption" }, text)) : (text))));
    }
    return (react_1.default.createElement(ExternalLink, { target: "_blank", href: processedUrl },
        react_1.default.createElement(material_1.ListItem, { disablePadding: true },
            react_1.default.createElement(material_1.ListItemButton, null,
                react_1.default.createElement(material_1.ListItemIcon, null,
                    react_1.default.createElement(InsertLinkOutlined_1.default, { htmlColor: "black" })),
                react_1.default.createElement(material_1.ListItemText, { primary: text })))));
};
exports.default = WebsiteTab;
